/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import systemAlert from "../../../utils/systemAlert";
import { viewLoading } from "../../../utils/loading";
import useForm from "../../../hooks/useForm";
import { isEmpty } from "../../../utils/lodashExtend";
import Icon from "../../Icon";
import Form from "../../Form";
import NoticeIcon from "../../../assets/images/icon/notice-icon.svg";
import { toast } from "../../../utils/toast";
import { ModalHeader } from "../../Modal";
import { addAdministrativeCertificate } from "../../../apis/tax-portal/administrativeCertificate";
import { TAX_ITEM_CODES } from "../../../constants/TaxPortal/ADMINISTRATIVE_CERTIFICATE";
import { shallowEqual, useSelector } from "react-redux";



const AdministrativeCertificateIssue = ({
  selectedItem,
  close: _cloase
}) => {

  const {
    taxpayerList,
  } = useSelector(
    (store) => ({
      taxpayerList: store.Data.taxpayerList,

    }),
    shallowEqual
  );

  const [buttons, setButtons] = useState([]);
  const [taxpayers, setTaxpayers] = useState([]);
  const [selectTaxpayer, setSelectTaxpayer] = useState(null);

  const reset = () => {
    resetForm();
    setSelectTaxpayer(null);
  };

  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    _cloase();
    reset();
  };

  const [fields, setFields] = useState([]);

  useEffect(() => {

    const taxpayers = (taxpayerList || []).map(item => {
      return {
        ...item,
        label: `${item.companyName} (${item.ceoName})`,
        value: item.idx,
      };
    });

    setTaxpayers([{ label: "선택안함", value: null }, ...taxpayers]);
  }, [taxpayerList]);


  const _submit = (_form) => {
    // const form = {
    //   ..._form,
    //   date: `${_form.date[0]}:00`,
    // };

    if (!form.taxpayerIdx) return systemAlert('수임처를 선택해주세요.');

    const datas = form;
    if (datas.issue_type === '개인') {

    } else if (datas.issue_type === '사업자') {
      datas.bizNm = datas.companyName;
      datas.bizNo = datas.bsno;
    }
    systemAlert(`"${selectedItem.label}" 발급신청하시겠습니까?`, {

      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '승인',
          onClick: () => {
            viewLoading(true);
            addAdministrativeCertificate(
              // managerCompany.companyIdx, 
              datas
            )
              .then((res) => {
                toast.success('신청되었습니다.');
                close();
              })
              .finally(() => {
                viewLoading(false);
              });
          }
        }
      ]
    });
  };

  const {
    form,
    errors,
    setValidateFields,
    setForm,
    handleOnChange,
    handleSubmit,
    resetForm,
  } = useForm({
    englCvaAplnYn: 'N',
    resnoOpYn: 'N',
    cvaDcumUseUsgCd: '99',
    cvaDcumSbmsOrgnClCd: '99',
    svcCd: selectedItem.id,
    ...(['B1022'].includes(selectedItem.id) ? {
      txnrmStrtYm: '2023',
      txnrmEndYm: '2023',
      bizNm: '',
      bizNo: '',
    } : {}),
    ...(['B1002'].includes(selectedItem.id) ? {
      txnrmStrtYm: '2023',
      txnrmEndYm: '2023',
      bizNm: '',
      bizNo: '',
    } : {}),
    ...(['B0005'].includes(selectedItem.id) ? {
      txnrmStrtYm: '202301',
      txnrmEndYm: '202312',
      bizNm: '',
      bizNo: '',
      itrfCd: 'all'
    } : {}),
    ...(['B0006'].includes(selectedItem.id) ? {
      bizNm: '',
      bizNo: '',
      cerpUsePupClCd: 'B0007'
    } : {}),
    ...(['B1003'].includes(selectedItem.id) ? {
      incClCd: '40',
      txnrmStrtYm: '200001',
      txnrmEndYm: '202312',
    } : {}),
    ...(['B4009'].includes(selectedItem.id) ? {
      txnrmStrtYm: '202301',
      txnrmEndYm: '202307',
    } : {}),

  },
    _submit,
    null,
    fields
  );

  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);

  useEffect(() => {
    !isEmpty(form) && setFields([
      [
        {
          title: "수임회사",
          key: "taxpayerIdx",
          type: "search-select",
          options: { list: taxpayers },
          zIndex: 100,
          isControlShouldRenderValue: true,
          onChange: (data) => {
            console.log(data);
            setForm({
              taxpayerIdx: data.value,
              companyName: data.companyName,
              bsno: data.bsno,
              ...(['B1022', 'B0005', 'B0006'].includes(selectedItem.id) ? {
                bizNm: data.ceoName,
              } : {})
            });
          },

        },
      ],
      [
        {
          title: "수임회사",
          key: "companyName",
          type: "text",
        },
        {
          title: "사업자번호",
          key: "bsno",
          type: "text",
          transform: ['comNum'],
        },
      ],
      ...(['B1022', 'B0005', 'B0006'].includes(selectedItem.id) ? [
        [
          {
            title: "이름",
            key: "bizNm",
            type: "text",
          },
          {
            title: "주민번호",
            key: "bizNo",
            type: "input",
            transform: ['jumin'],
          },
        ],
      ] : []),
      [
        {
          title: "발급언어",
          key: "englCvaAplnYn",
          type: "select",
          options: {
            list: [{
              label: '한글증명',
              value: 'N'
            }, {
              label: '영문증명',
              value: 'Y'
            }],
          },
        },
        {
          title: "주민등록번호 공개",
          key: "resnoOpYn",
          type: "select",
          options: {
            list: [{
              label: '비공개',
              value: 'N'
            }, {
              label: '공개',
              value: 'Y'
            }],
          },
        },

      ],
      [
        {
          title: "사용용도",
          key: "cvaDcumUseUsgCd",
          type: "select",
          options: {
            list: [
              {
                label: '기타',
                value: "99"
              },
              {
                label: '입찰, 계약용',
                value: "01"
              },
              {
                label: '수금용',
                value: "02"
              },
              {
                label: '관공서제출용',
                value: "03"
              },
              {
                label: '대출용',
                value: "04"
              },
              {
                label: '여권또는비자신청용',
                value: "05"
              },
              {
                label: '국민건강보험공단제출용',
                value: "06"
              },
              {
                label: '금융기관제출용',
                value: "07"
              },
              {
                label: '신용카드발급용',
                value: "08"
              },
            ],
          },
        },
        {
          title: "제출처",
          key: "cvaDcumSbmsOrgnClCd",
          type: "select",
          options: {
            list: [
              { label: "기타", value: "99" },
              { label: "금융기관", value: "01" },
              { label: "관공서", value: "02" },
              { label: "조합/협회", value: "03" },
              { label: "거래처", value: "04" },
              { label: "학교", value: "05" },
              { label: "외교부/재외공관", value: "06" },
            ],
          },
        },
      ],
      ...(['B1022', 'B1002'].includes(selectedItem.id) ? [
        [
          {
            title: '과세기간시작',
            key: 'txnrmStrtYm',
            type: "select",
            options: {
              list: [
                { label: "2023", value: "2023" },
                { label: "2022", value: "2022" },
                { label: "2021", value: "2021" },
                { label: "2020", value: "2020" },
                { label: "2019", value: "2019" },
                { label: "2018", value: "2018" },
                { label: "2017", value: "2017" },
                { label: "2016", value: "2016" },
              ],
            },
          },
          {
            title: '과세기간종료',
            key: 'txnrmEndYm',
            type: "select",
            options: {
              list: [
                { label: "2023", value: "2023" },
                { label: "2022", value: "2022" },
                { label: "2021", value: "2021" },
                { label: "2020", value: "2020" },
                { label: "2019", value: "2019" },
                { label: "2018", value: "2018" },
                { label: "2017", value: "2017" },
                { label: "2016", value: "2016" },
              ],
            },
          }
        ]
      ] : []),
      ...(['B0006'].includes(selectedItem.id) ? [
        [
          {
            title: '신청유형',
            key: 'issue_type',
            type: "select",
            options: {
              list: [
                { label: "개인", value: "개인" },
                { label: "사업자(법인만)", value: "사업자" },
              ],
            },
          },
          {
            title: '사용목적',
            key: 'cerpUsePupClCd',
            type: "select",
            options: {
              list: [
                { label: "기타", value: "B0007" },
                { label: "대금수령", value: "B0006" },
              ],
            },
          }
        ]
      ] : []),
      ...(['B1003'].includes(selectedItem.id) ? [
        [
          {
            title: '소득구분',
            key: 'incClCd',
            type: "select",
            options: {
              list: [
                { label: "사업소득", value: "40" },
                { label: "부동산임대소득", value: "30" },
              ],
            },
          },
          {
            title: '사업연도종료년월',
            key: 'txnrmEndYm',
            type: "input",
            after: '예시 : 202312'
          }
        ]
      ] : []),
      ...(['B0005'].includes(selectedItem.id) ? [
        [
          {
            title: '신청유형',
            key: 'issue_type',
            type: "select",
            options: {
              list: [
                { label: "개인", value: "개인" },
                { label: "사업자", value: "사업자" },
              ],
            },
          },
          {
            title: '세목',
            key: 'itrfCd',
            type: "select",
            options: {
              list: TAX_ITEM_CODES,
            },
          }
        ],
        [
          {
            title: '과세기간시작',
            key: 'txnrmStrtYm',
            type: "input",
            after: '예시 : 202301'
          },
          {
            title: '과세기간종료',
            key: 'txnrmEndYm',
            type: "input",
            after: '예시 : 202312'
          }
        ],
      ] : []),
      ...(['B4009'].includes(selectedItem.id) ? [

        [
          {
            title: '과세기간시작',
            key: 'txnrmStrtYm',
            type: "input",
            after: '예시 : 202401, 1기(01~06월), 2기(07~12월)'
          },
          {
            title: '과세기간종료',
            key: 'txnrmEndYm',
            type: "input",
            after: '예시 : 202407,  1기(01~06월), 2기(07~12월)'
          }
        ],
      ] : []),

      // {
      //   title: "작업일",
      //   key: "date",
      //   type: "datetimepicker",
      //   required: true,
      //   component: () => {
      //     return <></>
      //     // return <>{dateToViewFormatWithDayNameWithTime(get(schedule, 'createdTime'))}</>;
      //   }
      // },
    ]);

  }, [form, taxpayers, selectTaxpayer]);


  useEffect(() => {
    setButtons([
      {
        label: "닫기",
        color: 'text',
        onClick: close
      },
      {
        label: "발급신청",
        onClick: handleSubmit,
      }]);
  }, []);

  return (
    <>
      <ModalHeader>
        <Icon src={NoticeIcon} />&nbsp;
        {selectedItem.label} 발급신청
      </ModalHeader>
      <Form
        isRequiredShow={true}
        fields={fields}
        form={form}
        onChange={handleOnChange}
        // submit={handleSubmit}
        // cancelText={'닫기'}
        // cancel={close}
        errors={errors}
        buttons={buttons}
      >
      </Form>
    </>

  );
};


export default AdministrativeCertificateIssue;
